import React, { FC } from "react";
import { ActionsGroup, DialogActions, DialogContent, FlatButton, NumberInput, RaisedButton } from "@evergis/ui";
import { useTranslation } from "react-i18next";

import { ModalDialog } from "../DialogComponents/ModalDialog";
import { useDialogReset } from "../../../hooks/useDialogs";
import { useSizeRanges } from "./hooks/useSizeRanges";
import { ContentFlex, Reverse } from "./styled";
import { Units } from "../../Classification/types";

export const SIZE_RANGES_DEFAULTS = {
  maxWidth: "23.5rem",
};

export const SizeRanges: FC = () => {
  const { t } = useTranslation();
  const resetDialog = useDialogReset();
  const {
    updateFrom,
    changeFrom,
    from,
    fromInput,
    updateTo,
    changeTo,
    to,
    toInput,
    max,
    min,
    isReversed,
    recalc,
    reverse,
  } = useSizeRanges();

  return (
    <ModalDialog maxWidth={SIZE_RANGES_DEFAULTS.maxWidth}>
      <DialogContent>
        <ContentFlex>
          <NumberInput
            onBlur={e => {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              updateFrom(e.target.rawValue);
            }}
            onChange={changeFrom}
            value={from}
            label={t("classification.minSize", { ns: "dialogs" })}
            counter
            width={"7.625rem"}
            min={min}
            max={max}
            ref={fromInput}
            zIndex={110}
            units={Units.Pixels}
          />
          <Reverse onClick={reverse} primary={isReversed} />
          <NumberInput
            onBlur={e => {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              updateTo(e.target.rawValue);
            }}
            onChange={changeTo}
            value={to}
            label={t("classification.maxSize", { ns: "dialogs" })}
            counter
            width={"7.625rem"}
            min={min}
            max={max}
            ref={toInput}
            zIndex={110}
            units={Units.Pixels}
          />
        </ContentFlex>
      </DialogContent>
      <DialogActions>
        <ActionsGroup>
          <RaisedButton onClick={recalc} primary>
            {t("actions.apply", { ns: "common" })}
          </RaisedButton>
          <FlatButton onClick={resetDialog}>{t("actions.cancel", { ns: "common" })}</FlatButton>
        </ActionsGroup>
      </DialogActions>
    </ModalDialog>
  );
};
